import React from "react";

export default class Maps extends React.Component {
    componentDidMount() {
        /*let map = DATA.apartments.maps[0];
         //this.props.history.push('/some/path');
         browserHistory.push('/map/' + map.id);*/
    }

    render() {
        let children = React.cloneElement(this.props.children, {data: this.props.data});

        return (
            <div>
                {children}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Maps.jsx